'use strict';
import './iscroll.less'
// 核心
import React from 'react';
import $ from 'jquery';
import classnames from 'classnames';

//
import Component from '../core/component';
import Enhance from '../core/enhance';
import keys from 'lodash/keys';
import pick from 'lodash/pick';
// 工具
import iscroll from '../libs/iscroll';
import Http from '../common/http';
import debug from 'debug';

const log = debug('common.iscroll');
let cache = {};

//function pick(obj, args = '') {
//    let ret = {}
//    args.split(',').forEach((v) => {
//        ret[v] = obj[v];
//    })
//    return ret;
//}

/**
 * 滚动条
 */
class Iscroll extends Component {
    state = {
        roll: false,
        reload: false
    };
    eventNames = ["onScroll"];

    constructor(props) {
        super(props);
        this.state.native = false;
    }

    componentDidMount() {

        let _keys = keys(Iscroll.defaultProps);

        let _option = pick(this.props, _keys);

        log(_option)

        this.state.iscroll = new iscroll(this.refs['content'], _option);

        //
        this.state.iscroll.on('scrollEnd', this.handlerScrollEnd);
        this.state.iscroll.on('scroll', this.handlerScroll);
        //this.state.iscroll.on('scrollMoveEnd', this.handlerScrollMoveEnd);


        cache[this.props.uuid] && cache[this.props.uuid] < 0 && this.state.iscroll.scrollTo(0, cache[this.props.uuid] || 0);
        this.state.timer = setInterval(this.handlerRefresh, 200);
        this.refs['content'].addEventListener('touchmove', (event) => {
            event.preventDefault();
        }, false);
    }

    /**
     * 在组件从 DOM 中移除的时候立刻被调用。
     */
    componentWillUnmount() {
        if (this.state.native) {

        } else {
            clearInterval(this.state.timer);
            this.state.iscroll.destroy();
            this.state.iscroll = null;
        }
    }

    /**
     * componentDidUpdate(object prevProps, object prevState)在更新发生之后调用。
     */
    componentDidUpdate(prevProps, prevState) {
    }


    render() {
        return (
            <div ref='content' className={classnames("c-iscroll", this.state.className)}
                 onTouchEnd={() => {
                     this.handlerScrollMoveEnd();
                 }}
            >
                <div ref="iscroll" className="c-iscroll-scroller">
                    <div ref="reload" className="c-iscroll-reload" style={{display: this.props.onReload ? '' : 'none'}}>
                        <div className="c-iscroll-reload-prompt">
                            <canvas ref="canvasReload" style={{height: '100%'}}/>
                        </div>
                    </div>
                    <Http ref="http"/>
                    {this.props.children}
                    <div ref="preload" className="c-iscroll-preload"/>
                </div>
            </div>
        );
    }

    /**
     *
     * @private
     */
    handlerRefresh = () => {
        if (this.state.roll == false) {
            let keep = this.props.keep;
            this.state.iscroll.refresh();
            if (keep === 'bottom') {
                this.scrollTop = 999999;
            }
        }
    }

    /**
     * 下拉结束
     * @param e
     */
    handlerScrollMoveEnd = (e) => {
        log('handlerScrollMoveEnd')
        if (this.state.reload == 1) {
            this.state.reload = 2;
            $(this.refs['reload']).addClass('active');
            this.state.iscroll.refresh();
            this.state.iscroll.scrollTo(0, this.refs.reload.clientHeight);

        }
    }

    /**
     *
     * @param e
     * @private
     */
    handlerScroll = (e) => {
        if (this.state.native) {
            let x = e.target.scrollLeft;
            let y = e.target.scrollTop;

            // 滚动条位置缓存
            if (this.props.uuid)
                cache[this.props.uuid] = y;

        } else {
            this.state.roll = true;
            if (this.state.iscroll) {
                // 滚动条位置
                let {x, y} = this.state.iscroll;

                // 滚动条位置缓存
                if (this.props.uuid)
                    cache[this.props.uuid] = y;

                // console.log(this.state.reload);

                //是否开启下拉刷新
                if (this.props.onReload && this.state.reload != 2) {


                    let h = this.refs.reload.clientHeight * 1.5;

                    // =========================================================

                    let canvas_2 = this.refs.canvasReload;
                    let ctx_2 = canvas_2.getContext('2d');

                    //在给定的矩形内清除指定的像素
                    ctx_2.clearRect(0, 0, canvas_2.width, canvas_2.height)

                    //起始一条路径，或重置当前路径
                    ctx_2.beginPath();

                    ctx_2.lineWidth = 4;
                    ctx_2.strokeStyle = "#ccc";


                    // 创建弧/曲线（用于创建圆形或部分圆）
                    ctx_2.arc(
                        canvas_2.width / 2,//圆的中心的 x 坐标。
                        canvas_2.height / 2,//圆的中心的 y 坐标。
                        canvas_2.height / 4, //圆的半径。
                        0,
                        360 * Math.PI / 180,
                        false
                    );

                    ctx_2.stroke();
                    ctx_2.closePath();
                    ctx_2.save();


                    if (this.refs.reload.clientHeight < y) {

                        let angle = 360 * ((y - this.refs.reload.clientHeight) / this.refs.reload.clientHeight * 2);

                        if (angle < 360) {
                            ctx_2.lineWidth = 4;
                            ctx_2.strokeStyle = "#367fa9";
                        } else {
                            angle = 360;
                            ctx_2.lineWidth = 10;
                            ctx_2.strokeStyle = "#367fa9";
                        }

                        //起始一条路径，或重置当前路径
                        ctx_2.beginPath();

                        // 创建弧/曲线（用于创建圆形或部分圆）
                        ctx_2.arc(
                            canvas_2.width / 2,//圆的中心的 x 坐标。
                            canvas_2.height / 2,//圆的中心的 y 坐标。
                            canvas_2.height / 4, //圆的半径。
                            0,
                            angle * Math.PI / 180,
                            false
                        );

                        ctx_2.stroke();
                        ctx_2.closePath();
                        ctx_2.save();
                    }
                    // =========================================================

                    log(y, '>', h, this.state.reload)
                    if (y > h) {
                        if (this.state.reload < 2) {
                            this.state.reload = 1;
                        }
                    } else {
                        if (this.state.reload < 2) {
                            this.state.reload = 0;
                        }
                    }
                }
                this._emit("onScroll", {x, y})
                this.props.onScroll && this.props.onScroll({x, y});
            }
        }
    }

    /**
     *
     * @param e
     */
    handlerScrollEnd = (e) => {
        let {x, y} = this.state.iscroll;
        this.props.onScroll && this.props.onScroll({x, y});

        if (this.state.reload == 2) {
            if (this.props.onReload) {
                this.props.onReload(() => {
                    this.handlerReloadComplete();
                })
            }
        }
        this.state.roll = false;
    }


    /**
     *
     */
    handlerReloadComplete = () => {
        this.state.reload = 0;
        $(this.refs['reload']).removeClass('active');
    }


    /**
     *
     * @param value
     */
    set scrollTop(value) {
        // console.log('scrollTop')
        if (this.state.native) {
        } else {
            let {maxScrollY} = this.state.iscroll;
            if (value > Math.abs(maxScrollY)) {
                value = Math.abs(maxScrollY);
            }
            this.state.iscroll.scrollTo(0, -value);
            this.props.uuid && (cache[this.props.uuid] = value);
        }
    }

    /**
     *
     */
    get scrollTop() {
        // console.log('scrollTop')
        return this.state.iscroll.y;
    }

    /**
     * 是否滚动到底部
     * @return {boolean}
     */
    get isScrollBottom() {
        let {maxScrollY, y} = this.state.iscroll;
        return maxScrollY == y;
    }
}

//https://blog.csdn.net/ihetqxl/article/details/36538665
Iscroll.displayName = "Iscroll";
Iscroll.defaultProps = {
    // 是否使用CSS3的Transform属性 true
    useTransform: true,
    // 是否使用CSS3的Transition属性，否则使用requestAnimationFram代替 true
    useTransition: true,
    // 是否启用硬件加速 true
    HWCompositing: true,
    // 是否启用弹力动画效果，关掉可以加速 true
    bounce: true,
    // 是否启用click事件。建议关闭此选项并启用自定义的tap事件（options.tap）false
    click: false,
    // 是否关闭鼠标事件探测。如知道运行在哪个平台，可以开启它来加速。 false
    disableMouse: false,
    // 是否关闭指针事件探测。如知道运行在哪个平台，可以开启它来加速。 false
    disablePointer: false,
    // 是否关闭触摸事件探测。如知道运行在哪个平台，可以开启它来加速。 false
    disableTouch: false,
    // 使用IScroll的横轴滚动时，如想使用系统立轴滚动并在横轴上生效，请开启。 false
    eventPassthrough: false,
    // 主要在上下左右滚动都生效时使用，可以向任意方向滚动。 false
    freeScroll: false,
    // 绑定按键事件。false
    keyBindings: false,
    // 反向鼠标滚轮。 false
    invertWheelDirection: false,
    // 是否开启动量动画，关闭可以提升效率。true
    momentum: true,
    // 是否监听鼠标滚轮事件。 false
    mouseWheel: true,
    // 是否屏蔽默认事件。true
    preventDefault: false,//
    // 是否显示默认滚动条 false
    scrollbars: true,
    // 滚动时显示滚动条，默认影藏，并且是淡出淡入效果
    fadeScrollbars: true,
    // 是否启用自定义的tap事件 可以自定义tap事件名 false
    tap: false,
    // 滚动条可以拖动 false
    interactiveScrollbars: false,
    //是否固定滚动条大小，建议自定义滚动条时可开启 false
    resizeScrollbars: true,
    // 当滚动边界之外的滚动条是由少量的收缩。'clip' or 'scale'.
    shrinkScrollbars: 'scale',

    // probeType：1对性能没有影响。在滚动事件被触发时，滚动轴是不是忙着做它的东西。
    // probeType：2总执行滚动，除了势头，反弹过程中的事件。这类似于原生的onscroll事件。
    // probeType：3发出的滚动事件与到的像素精度。注意，滚动被迫requestAnimationFrame（即：useTransition：假）。
    probeType: 3,
    //回弹时间
    bounceTime: 300,
    // 自定义个一个属性 在页面高度不够的时候也能使用弹性效果
    bounceY: true,
    // 自定义个一个属性 在页面高度不够的时候也能使用弹性效果
    bounceX: false,
    // 光标、触摸超出容器时，是否停止滚动
    bindToWrapper: true,
}
export default Iscroll
